module.exports = __webpack_public_path__ + "static/ciceron-bw-a4e0d02b70b1846c7b2942dd401a8c82.jpg";